// extracted by mini-css-extract-plugin
export default {"error404":"style_error404__i3oGv","container":"style_container__k0zqi","error404__text":"style_error404__text__qY8jb","orangeGradient-btn":"style_orangeGradient-btn__9v9q9"};